import React from "react";
import { WrapperFilterOption, WrapperFiltersTable } from "../styles";
import { Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";

export const FiltersTable = ({ setSelectedKeys, confirm, selectedKeys }) => {
  const statusFilters = [
    { text: "Active", value: "Active" },
    { text: "Inactive", value: "Inactive" },
    { text: "Unconfirmed", value: "Unconfirmed" },
  ];

  const handleClick = (value) => {
    if (selectedKeys && selectedKeys[0] === value) {
      setSelectedKeys([]);
    } else {
      setSelectedKeys([value]);
    }
    confirm();
  };

  return (
    <WrapperFiltersTable>
      {statusFilters.map((filter, indx) => (
        <WrapperFilterOption
          key={indx}
          onClick={() => handleClick(filter.value)}
          style={{
            background: selectedKeys && selectedKeys[0] === filter.value ? theme.colors.salmon1 : "transparent",
            cursor: "pointer"
          }}
        >
          <Text 
            color={theme.colors.grey2}
            fontSize={theme.fonts.size.sm}
            fontFamily={theme.fonts.family}
          > 
            {filter.text}
          </Text>
        </WrapperFilterOption>
      ))}
    </WrapperFiltersTable>
  );
};